document.addEventListener("DOMContentLoaded", function () {
  document.querySelector('.collection-nav-button').addEventListener('click', function () {
    document.querySelector(".collection-nav__wrapper").classList.toggle('active');
    document.querySelector('body').classList.add('collection-drawer-active');
  });

  document.querySelector('.collection-nav-button-close').addEventListener('click', function () {
    document.querySelector(".collection-nav__wrapper").classList.remove('active');
    document.querySelector('body').classList.remove('collection-drawer-active');
  });

  const buttons = document.querySelectorAll('.navigation__button');

  buttons.forEach(button => {
    button.addEventListener('click', function (event) {
      event.stopPropagation();

      const submenu = this.closest('.mm-nav__inner').nextElementSibling;
      const isActive = this.classList.contains('active');
      if (!isActive) {
        this.classList.add('active');
        submenu.classList.add('show');
      } else {
        this.classList.remove('active');
        submenu.classList.remove('show');
      }
    });
  });

  const openParentAccordions = () => {
    const activeMenus = document.querySelectorAll('.collection-nav__wrapper .navigation__link.active-menu');
    activeMenus.forEach(activeMenu => {
      const parentSubmenu = activeMenu.closest('.navigation__submenu');
      if (parentSubmenu) {
        parentSubmenu.classList.add('show');
        const parentButton = parentSubmenu.parentElement.querySelector('.navigation__button');
        if(parentButton) parentButton.classList.add('active');
        let parentOfParentSubmenu = parentSubmenu.parentElement.closest('.navigation__submenu');
        if (parentOfParentSubmenu) {
          parentOfParentSubmenu.classList.add('show');
          const parentOfParentButton = parentOfParentSubmenu.parentElement.querySelector('.navigation__button');
          if(parentOfParentButton) parentOfParentButton.classList.add('active');
        }
      }
    });
  };

  openParentAccordions();
});
